import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

/**
 * Tiebreaker modal shown when apuration ends in a tie.
 * Lets the admin pick the winning band, choose a tiebreak method, and justify the decision.
 */
export function TiebreakerDialog({ open, stage, tieForm, setTieForm, onSubmit, onOpenChange, busy }) {
  if (!stage) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border">
        <DialogHeader><DialogTitle>Definir vencedora (desempate)</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Banda vencedora</Label>
            <Select
              value={tieForm.winner_band_id}
              onValueChange={(v) => setTieForm({ ...tieForm, winner_band_id: v })}
            >
              <SelectTrigger className="mt-1"><SelectValue placeholder="Selecionar" /></SelectTrigger>
              <SelectContent>
                <SelectItem value={stage.band_a_id}>{stage.band_a?.name}</SelectItem>
                <SelectItem value={stage.band_b_id}>{stage.band_b?.name}</SelectItem>
                {stage.bands_count === 3 && stage.band_c_id && (
                  <SelectItem value={stage.band_c_id}>{stage.band_c?.name}</SelectItem>
                )}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Critério de desempate</Label>
            <Select
              value={tieForm.tiebreaker_method}
              onValueChange={(v) => setTieForm({ ...tieForm, tiebreaker_method: v })}
            >
              <SelectTrigger className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="nova_votacao">Nova votação rápida</SelectItem>
                <SelectItem value="decisao_organizacao">Decisão da organização</SelectItem>
                <SelectItem value="sorteio">Sorteio público</SelectItem>
                <SelectItem value="outro">Outro</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Justificativa*</Label>
            <Textarea
              rows={3}
              value={tieForm.justification}
              onChange={(e) => setTieForm({ ...tieForm, justification: e.target.value })}
              className="mt-1"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button
            onClick={onSubmit}
            disabled={busy}
            className="bg-[var(--g66-amber)] text-black hover:bg-[var(--g66-amber-2)]"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Confirmar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
